module.exports = __webpack_public_path__ + "static/media/ye.a2eb90aa.svg";